/**
 * @module Widget
 */

import { Component, Input, EventEmitter, Output } from '@angular/core';
import { WidgetLayersClass } from '@class/widgetLayers.class';
import { LanguageType } from '@models/language.model';
import { Subscription } from 'rxjs';
import { ItemColor, ItemIcon } from '@functions/item.functions';
import { AuthService } from '@services/auth/auth.service';

@Component({
  selector: 'app-widget-designer-dates-bounds',
  templateUrl: './widget-designer-dates-bounds.component.html',
  styleUrls: ['./widget-designer-dates-bounds.component.css']
})
export class WidgetDesignerDatesBoundsComponent {

  @Input() widgetLayers: WidgetLayersClass;
  @Output() sendGotoFiltersAndDates: EventEmitter<void>;

  language: LanguageType;
  language$sub: Subscription

  color = ItemColor('indicators');
  icon = ItemIcon('indicators');

  constructor(
    private $auth: AuthService
  ) {
    this.sendGotoFiltersAndDates = new EventEmitter<void>();

    this.language$sub = this.$auth.language$.subscribe({
      next: (language: LanguageType) => {
        this.language = language;
      }
    });
  }

  onGoto() {
    this.sendGotoFiltersAndDates.emit();
  }

}
